import type { VideoProps } from './types';
import Video from './Video';

export default Video;
export type { VideoProps };
